<template>
  <div class="menu-title flex" :class="{ folder: isFolder, collapse }">
    <div class="title__label flex-main">{{ menu.title }}</div>
    <div class="title__extra" v-if="!collapse">
      <template v-if="CMenuExtraComponent">
        <CMenuExtraComponent :menu="menu" :isFolder="isFolder" />
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, useHostAppInstance } from '@zto/zpage'

const props = defineProps<{
  menu?: any
  collapse?: boolean
}>()

const app = useHostAppInstance()
const menuConfig = app.useAppConfig('menu.extra', {})

const CMenuExtraComponent = app.resolveComponent(menuConfig.extra?.component || 'CAppMenuExtra')

const isFolder = computed(() => {
  return !props.menu?.path
})
</script>

<style lang="scss" scoped>
.menu-title {
  &.folder.collapse {
    .title__label {
      display: none;
    }
  }

  &__extra {
  }
}
</style>
